import styled from 'styled-components';
import { ExpectedDataProps } from '../data';
import { userGradeType } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

interface Props {
  item: ExpectedDataProps;
}

function ScheduledCard({ item }: Props) {
  const { modalDispatch } = useModal();
  return (
    <Card
      onClick={async () => {
        const grade = await userGradeType();
        if (!grade) {
          modalDispatch({ type: 'USER_ALERT', payload: 'free' });
          return;
        }
        if (item.caseno.includes('*')) {
          modalDispatch({ type: 'USER_ALERT', payload: 'local' });
          return;
        }
        window.location.href = `/scheduled/detail/${item.t_idx}`;
      }}
    >
      <ItemInfoBox>
        <div>
          {item.caseno} | {item.court}
        </div>
        <ItemTypeChip>예정</ItemTypeChip>
      </ItemInfoBox>
      <ListCardContentBox>
        <CardTextBox>
          <CardTitle>{item.addr}</CardTitle>
          <div>
            <CaseNumberBox>
              <span>접수일</span>
              {item.reg_date ? item.reg_date.split('T')[0] : '-'}
            </CaseNumberBox>
            <CaseNumberBox>
              <span>개시일</span>
              {item.dec_date ? item.dec_date.split('T')[0] : '-'}
            </CaseNumberBox>
            <CaseNumberBox>
              <span>배당일</span>
              {item.div_date ? item.div_date.split('T')[0] : '-'}
            </CaseNumberBox>
          </div>
        </CardTextBox>
        <CardImgBox>
          <div style={{ position: 'relative' }}>
            <img
              src="/assets/images/no-image.svg"
              alt=""
              style={{
                height: 80,
                width: 80,
                borderRadius: 8,
              }}
            />
            {/* <img
                              src={`/assets/images/icon/${item.is_like ? 'white-border-star' : 'white-border-gray-star'}.svg`}
                              alt=""
                              style={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                              }}
                              onClick={(e) => {
                                // e.stopPropagation();
                                // if (page === 'mypattern') {
                                //   return;
                                // }
                                // if (!item.is_like) {
                                //   setSelectedIdx(item.iidx2);
                                //   setShowLikeModal && setShowLikeModal(true);
                                // } else {
                                //   handleDisLikeItem(item.iidx2);
                                // }
                              }}
                            /> */}
          </div>

          <ViewCount>
            <img src="/assets/images/icon/view-gray.svg" alt="" />
            <span>{item.count ?? 0}회</span>
          </ViewCount>
        </CardImgBox>
      </ListCardContentBox>
    </Card>
  );
}

export default ScheduledCard;

const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid #70737c29;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
  cursor: pointer;
`;

const ItemInfoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #37383c9c;
`;
const ItemTypeChip = styled.span`
  width: 42px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  background-color: #ffecd9;
  color: #c86700;
`;
const ListCardContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
`;
const CardTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const CardTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #171e26;
  line-height: 150%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CaseNumberBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;

  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 12px;
    line-height: 145%;
    letter-spacing: -2%;
    color: #616161;
  }
`;

const CardImgBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
`;

const ViewCount = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: rgba(55, 56, 60, 0.61);
`;
